import { useEffect, useState } from "react";
import { fetchOooByHotelIds } from "../services/oooService";

export function useOooData(hotelIds) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false); // start as false
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const numericIds = (hotelIds || [])
        .map((id) => Number(id))
        .filter((id) => !isNaN(id));

    if (numericIds.length === 0) {
        setData({});
        setError(null);
        setLoading(false);
        return;
    }

    async function load() {
        try {
        setLoading(true);
        setError(null);
        const result = await fetchOooByHotelIds(numericIds);

        if (!mounted) return;

        // normalize keys to numbers
        const normalizedResult = {};
        for (const [key, value] of Object.entries(result)) {
            normalizedResult[Number(key)] = value;
        }

        setData(normalizedResult);
        } catch (err) {
        if (mounted) setError(err.message || "Failed to fetch OOO data");
        } finally {
        if (mounted) setLoading(false);
        }
    }

    load();
    return () => (mounted = false);
    }, [hotelIds]);


  return { data, loading, error };
}
